"use client"

import { Container } from "../../components/landing/components/Container"
import { Footer } from "../../components/landing/Footer"
import { Header } from "../../components/landing/Header"

export default function Contact() {
  const googleFormEmbedUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLScEfzSa19EfrNKzJCyJ3gbqfHEKUfTd6zuiAT4uEOpS0XEKcg/viewform?usp=sf_link"

  return (
    <>
      <div className="min-h-screen bg-gray-950">
        <Header />
        <Container className="mt-16 px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-slate-50 mb-6">
              Contact Us
            </h1>
            <p className="text-lg text-slate-50 mb-8">
              If you have any questions, you can use the form below to contact
              us:
            </p>
            <div className="rounded-lg shadow-xl overflow-hidden">
              <iframe
                src={googleFormEmbedUrl}
                width="100%"
                height="600"
                frameBorder="0"
                className="w-full"
              >
                Loading...
              </iframe>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}
